<template>
    <div class="mt-4 rounded-lg border border-iron-200 bg-white p-2 sm:p-4">
        <div v-if="!loading">
            <p
                v-if="invoices.length === 0"
                class="text-center text-sm text-iron-600"
            >
                {{ $t("billing.invoices.no_invoices") }}
            </p>

            <Table v-else>
                <TableHeader>
                    <TableRow>
                        <TableHead class="w-[200px]">
                            {{ $t("billing.invoices.date") }}
                        </TableHead>
                        <TableHead>
                            {{ $t("billing.invoices.description") }}</TableHead
                        >
                        <TableHead>{{
                            $t("billing.invoices.amount")
                        }}</TableHead>
                        <TableHead> </TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    <TableRow v-for="invoice in invoices" :key="invoice.id">
                        <TableCell class="font-medium">
                            {{ invoice.issued_at }}
                        </TableCell>
                        <TableCell> Zaptime professional</TableCell>
                        <TableCell> {{ invoice.amount_currency }} </TableCell>
                        <TableCell class="text-right"
                            ><a
                                :href="
                                    route('app.invoices.downloads.pdf', {
                                        invoice: invoice.id,
                                    })
                                "
                                target="_blank"
                                class="text-orange-600 hover:text-orange-900"
                                >{{ $t("billing.invoices.download") }}</a
                            ></TableCell
                        >
                    </TableRow>
                </TableBody>
            </Table>
        </div>

        <div v-if="loading"></div>
    </div>
</template>

<script setup lang="ts">
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import { onMounted, ref } from "vue";
import route from "ziggy-js";
import axios from "axios";

type Invoice = {
    id: number;
    issued_at: string;
    amount_currency: string;
};

const invoices = ref<Invoice[]>([]);
const loading = ref(true);

async function getInvoices() {
    try {
        const response = await axios.get(route("app.invoices.index"));
        invoices.value = response.data.data.invoices;
    } catch (error) {
        console.error(error);
    } finally {
        loading.value = false;
    }
}

onMounted(async () => {
    await getInvoices();
});
</script>
